<div class="banner">
  <div class="banner__content" [ngClass]="isIceMachinePage ? 'ice_img' : 'purifier_img'">
    <div class="banner__content__text">
      <h1 [innerText]="title"></h1>
      <p [innerText]="subtitle"></p>
    </div>
  </div>
</div>